import { BASE_URL } from "../../../shared/utils/variables";
import { getAuthHeaders } from "../../../shared/services/authentication";

const baseURL = BASE_URL;

export const fetchRubricas = async () => {
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas`, options);
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro ao buscar rubricas:', error);
        throw error;
    }
}

export const fetchRubricaService = async (id: string) => {
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubrica/${id}`, options);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Erro ao buscar rubrica:', error);
        throw error;
    }
}

export const fetchRubricasGrouped = async () => {
    const options = {
        method: 'GET',
        headers: {
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(`${baseURL}/rubricas-grouped`, options);
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro ao buscar rubricas agrupadas:', error);
        throw error;
    }
}

export interface RubricaPayload {
    name: string;
    description?: string;
    typeId?: string | null;
    clientId?: string;
}

export const createRubricaService = async (payload: RubricaPayload) => {
    const response = await fetch(`${baseURL}/rubrica`, {
        method: 'POST',
        headers: {
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return response.json();
};

export const fetchRubricaTypesService = async () => {
    const response = await fetch(`${baseURL}/rubrica-types`, {
        method: 'GET',
        headers: {
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return response.json();
};